/**
 * @author Andres Solarte
 * @file routes.js
 * @description Patient Records routes
 */

// Pages
import PatientManagement from '@nephro/pages/Patients/PatientManagementRecords';
import PatientCreation from '@nephro/pages/Patients/PatientCreation';
import PatientViewEdit from '@nephro/pages/Patients/PatientViewEdit';

const pathStart = '/main/patient_records';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: PatientManagement,
    exact: true
  },
  {
    path: `${pathStart}/edit/:id`,
    isProtected: true,
    component: PatientViewEdit,
    exact: true
  },
  {
    path: `${pathStart}/view/:id`,
    isProtected: true,
    component: PatientViewEdit,
    exact: true
  },
  {
    path: `${pathStart}/create`,
    isProtected: true,
    component: PatientCreation,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
